import { render, staticRenderFns } from "./ownerOrder.vue?vue&type=template&id=d8d22510&scoped=true&"
import script from "./ownerOrder.vue?vue&type=script&lang=js&"
export * from "./ownerOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d22510",
  null
  
)

export default component.exports